import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'piqet-angular-table-of-content',
  templateUrl: './table-of-content.component.html',
  styleUrls: ['./table-of-content.component.scss'],
})
export class TableOfContentComponent implements OnChanges {
  @Input() isTocVisible = false;
  @Input() tocSections: any;
  @Output() scrollEmit: EventEmitter<string> = new EventEmitter();
  @Output() toggleBtn: EventEmitter<string> = new EventEmitter();
  @Input() reportAccessData: any;
  @Input() isCustomReport: boolean = true;

  ngOnChanges(changes: SimpleChanges): void {
    this.isTocVisible = changes['isTocVisible']?.currentValue;
  }

  toggleToc() {
    this.toggleBtn.emit('toggle');
  }

  scrollToElement(elementId: string) {
    const element = document.getElementById(elementId);
    if (element) {
      const y = element.getBoundingClientRect().top + window.pageYOffset - 200;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  }
}
